import Button from "component/ui/Button";
import React, { useMemo } from "react";
import { getTotalCountData } from "./paymentCalculator";

const PaymentSummary = ({
  onClose,
  handleNext,
  slots,
  setPaymentData,
  cardLoader
}) => {

  const { slotPrice, gst, serviceFee, total } = useMemo(() => {
    const totalCountData = getTotalCountData(slots);
    setPaymentData(totalCountData);
    return { slotPrice: totalCountData?.basePrice, gst: totalCountData?.totalGst, serviceFee: totalCountData?.serviceFee, total: totalCountData?.total };
  }, [slots]);

  return (
    <div
      className="md:p-5 p-3 bg-white rounded-lg relative w-96"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center"
      >
        ✕
      </button>

      {/* Header */}
      <div className="text-center mb-3">
        <h2 className="md:text-2xl text-lg font-medium">
          Payment Summary
        </h2>
      </div>

      <div className="my-4 border-t" />

      {/* Breakdown */}
      <div className="flex justify-between">
        <div>
          <p>Slot Price</p>
          <p>Service Fees (inc. GST)</p>
        </div>
        <div className="text-right">
          <p>${slotPrice.toFixed(2)}</p>
          <p>${(serviceFee + gst).toFixed(2)}</p>
        </div>
      </div>

      <div className="my-4 border-t" />

      {/* Total */}
      <div className="text-center">
        <p>Total Booking Fees</p>
        <p className="text-lg font-semibold">
          ${total.toFixed(2)}
        </p>

        <div className="mt-3">
          <Button onClick={handleNext} style={{ minWidth: "6rem" }} disabled={cardLoader}>
            {cardLoader ? "Loading..." : 'Next'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSummary;